import { ConfirmSheet } from '@/components/ConfirmSheet'
import {
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
} from '@/components/ModalSheet'

export interface RemoveDocumentRequestDialogProps {
  showing: boolean
  onConfirm: () => unknown
  onDecline: () => unknown
  testId?: string
}

/**
 * Confirms removing a document from its request slot.
 */
export function RemoveDocumentRequestDialog({
  showing,
  onConfirm,
  onDecline,
  testId,
}: RemoveDocumentRequestDialogProps) {
  return (
    <ConfirmSheet
      showing={showing}
      onConfirm={onConfirm}
      onDecline={onDecline}
      danger
      yes="Remove"
      confirmButtonTestId={testId && `${testId}-confirm`}
      declineButtonTestId={testId && `${testId}-decline`}
      closeButtonTestId={testId && `${testId}-close`}
    >
      <ModalSheetContentBlock>
        <ModalSheetContentTitle>Are you sure?</ModalSheetContentTitle>
        <ModalSheetContentDescription>
          The document will be removed from the slot but will remain linked.
        </ModalSheetContentDescription>
      </ModalSheetContentBlock>
    </ConfirmSheet>
  )
}
